import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "mandatory" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_iuf_select = _resolveComponent("iuf-select")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_validity_form = _resolveComponent("validity-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    loading: _ctx.loading,
    title: _ctx.t('TITLE.ADD', { object: _ctx.t('ALLIANCE.LOW.SING') }),
    onCancel: _ctx.cancel,
    onConfirm: _ctx.onSubmit,
    "form-width": "700",
    "disable-confirm": _ctx.disableConfirm,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, { class: "bg-white" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_form, {
            id: "alliance-form",
            ref: "allianceForm"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "column q-mx-sm" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { class: "q-pt-sm q-pb-md" }), _toDisplayString(_ctx.t('DEFINITION')), 17),
                  _createVNode(_component_q_input, _mergeProps({ autofocus: "" }, _ctx.INPUT_LG, {
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                    "label-slot": "",
                    class: "full-width",
                    placeholder: _ctx.t('NAME.PLACEHOLDER'),
                    rules: [(val) => val?.trim().length > 0 && val?.trim().length <= _ctx.MAX_LENGTH.ALLIANCE.NAME]
                  }), {
                    label: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('NAME.LABEL')) + " ", 1),
                      _hoisted_1
                    ]),
                    error: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: _ctx.ICONS_NAME.WARNING_SOLID
                      }, null, 8, ["name"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.name?.trim().length > 0
                                            ? _ctx.t('NAME.ERROR.LONG', { x: _ctx.MAX_LENGTH.ALLIANCE.NAME })
                                            : _ctx.t('VALIDATION.REQUIRED.SING', { attribute: _ctx.t('NAME.LABEL') })), 1)
                    ]),
                    _: 1
                  }, 16, ["modelValue", "placeholder", "rules"]),
                  _createVNode(_component_iuf_select, _mergeProps({
                    modelValue: _ctx.type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
                    label: _ctx.t('TYPE.LABEL'),
                    loading: _ctx.loadingTypes,
                    rules: [_ctx.validateAllianceType]
                  }, _ctx.SELECT_SINGLE_LG_SEARCH, {
                    options: _ctx.typeOptions,
                    "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_SINGLE'),
                    mandatory: "",
                    "option-label": "label",
                    "option-value": "dobjId",
                    "selected-item-slot": "",
                    onFilter: _ctx.searchTypes
                  }), {
                    error: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: _ctx.ICONS_NAME.WARNING_SOLID
                      }, null, 8, ["name"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('VALIDATION.REQUIRED.SING', { attribute: _ctx.t('TYPE.LABEL') })), 1)
                    ]),
                    "selected-item": _withCtx((scope) => [
                      _createVNode(_component_iap_chip, {
                        tooltip: "",
                        label: scope.opt.label
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 16, ["modelValue", "label", "loading", "rules", "options", "placeholder-value", "onFilter"]),
                  _createVNode(_component_iuf_select, _mergeProps({
                    modelValue: _ctx.companies,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companies) = $event)),
                    label: _ctx.t('COMPANIES.LABEL'),
                    loading: _ctx.loadingCompanies,
                    rules: [_ctx.validateCompanies]
                  }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                    options: _ctx.companyOptions,
                    "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                    mandatory: "",
                    "option-label": "name",
                    "option-value": "dobjId",
                    "selected-item-slot": "",
                    onFilter: _ctx.searchCompanies
                  }), {
                    error: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: _ctx.ICONS_NAME.WARNING_SOLID
                      }, null, 8, ["name"]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t('VALIDATION.REQUIRED.PLUR', { attribute: _ctx.t('COMPANIES.LABEL') })), 1)
                    ]),
                    "selected-item": _withCtx((scope) => [
                      _createVNode(_component_iap_chip, {
                        tooltip: "",
                        icon: _ctx.ICONS_NAME.COMPANY_OUTLINE,
                        label: scope.opt.name,
                        removable: "",
                        onRemove: ($event: any) => (scope.toggleOption(scope.opt))
                      }, null, 8, ["icon", "label", "onRemove"])
                    ]),
                    _: 1
                  }, 16, ["modelValue", "label", "loading", "rules", "options", "placeholder-value", "onFilter"]),
                  _createVNode(_component_iuf_select, _mergeProps({
                    modelValue: _ctx.leads,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.leads) = $event))
                  }, _ctx.SELECT_MULTIPLE_LG_SEARCH, {
                    label: _ctx.t('LEAD.CAP.PLUR'),
                    options: _ctx.leadOptions,
                    rules: [_ctx.validateLeads],
                    "option-label": "name",
                    "selected-item-slot": "",
                    "placeholder-value": _ctx.t('PLACEHOLDER.SELECT_MULTIPLE'),
                    "option-value": "dobjId",
                    mandatory: !!_ctx.defaultLead,
                    onFilter: _ctx.leadsSearch
                  }), {
                    "selected-item": _withCtx((scope) => [
                      _createVNode(_component_iap_chip, {
                        tooltip: "",
                        icon: _ctx.ICONS_NAME.FILE_OUTLINE,
                        label: scope.opt.name,
                        removable: "",
                        onRemove: ($event: any) => (scope.toggleOption(scope.opt))
                      }, null, 8, ["icon", "label", "onRemove"])
                    ]),
                    _: 1
                  }, 16, ["modelValue", "label", "options", "rules", "placeholder-value", "mandatory", "onFilter"]),
                  _createElementVNode("span", _mergeProps(_ctx.TEXT_TERTIARY_TITLE, { class: "q-pt-lg q-pb-md" }), _toDisplayString(_ctx.t('VALIDITY')), 17),
                  _createVNode(_component_iuf_select, _mergeProps({
                    modelValue: _ctx.status,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event))
                  }, _ctx.SELECT_SINGLE_LG, {
                    label: _ctx.t('STATUS.LABEL'),
                    options: _ctx.availableStatuses,
                    "no-tooltip": "",
                    mandatory: "",
                    "no-option-slot": "",
                    "selected-item-slot": ""
                  }), {
                    "selected-item": _withCtx((scope) => [
                      _createVNode(_component_iap_chip, {
                        tooltip: "",
                        "uncut-label": "",
                        class: "q-pr-xs",
                        icon: _ctx.allianceStatusIcon(scope.opt),
                        "icon-color": _ctx.allianceStatusColorClass(scope.opt),
                        label: _ctx.allianceStatusLabel(scope.opt)
                      }, null, 8, ["icon", "icon-color", "label"])
                    ]),
                    option: _withCtx((scope) => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: _ctx.allianceStatusIcon(scope.opt),
                            color: _ctx.allianceStatusColorClass(scope.opt)
                          }, null, 8, ["name", "color"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, _mergeProps({ lines: 1 }, _ctx.TEXT_CONTENT_BODY), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.allianceStatusLabel(scope.opt)), 1)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(Object.assign({}, _ctx.TOOLTIP_PROPS, { anchor: 'bottom middle', self: 'top middle', offset: [0, 4] }))), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.allianceStatusLabel(scope.opt)), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 1
                  }, 16, ["modelValue", "label", "options"]),
                  _createVNode(_component_validity_form, {
                    "effective-date": _ctx.effectiveDate,
                    "onUpdate:effectiveDate": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.effectiveDate) = $event))
                  }, null, 8, ["effective-date"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "title", "onCancel", "onConfirm", "disable-confirm"]))
}